import LineString from "ol/geom/LineString";
import Point from "ol/geom/Point";
import PreUndoData from "./PreUndoData";
import * as _ from 'lodash'
import Feature from "ol/Feature";
import LineStringFeature from "./LineStringFeature";

export default class RestoreTrackData extends PreUndoData {
    constructor(trackId: string, dotLngLats: Point[], trackLngLatFeatures: LineStringFeature[]) {
        super()
        this.trackId = trackId
        this.dotLngLats = _.cloneDeep(dotLngLats) // if we don't clone, then if the array gets reversed, the copy in here will get reversed too, which we don't want
        this.trackLngLatFeatures = _.cloneDeep(trackLngLatFeatures)
    }
    trackId: string
    dotLngLats: Point[]
    trackLngLatFeatures: LineStringFeature[]
}